import React from 'react';
import { injectIntl } from 'react-intl';

import { Modal } from 'sa-ui';

import messages from './SimulatedRemoveModalMessages';

function SimulatedRemoveProblemModal({ intl, isOpen, feedback, onClose, onContinue }) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      icon="pe-7s-close-circle"
      title={intl.formatMessage(messages.problem)}
      subtitle={feedback}
      buttons={[
        {
          label: intl.formatMessage(messages.continue),
          onClick: onContinue,
          primary: true,
        },
      ]}
      small
    />
  );
}

export default injectIntl(SimulatedRemoveProblemModal);
